function getParams(loc){
  loc = loc || window.location.href;
  var out = {}, match;
  var rx = /[\?&]([^=&]+)(?:=([^&]+))/g;
  while(match = rx.exec(loc)) out[match[1]] = match[2];
  var id = window.location.href.match(/(?:\/embed\/locations\/)([a-zA-Z0-9-\_)]+)/);
  out['id'] = id && id.length > 0 ? id[0] : null;
  return out;
}

document.addEventListener("DOMContentLoaded", 
  function() {    
    var params = getParams(),
        options = {
          element: document.getElementById('root'), 
          id: params.id,
          details: params.details || false,
          listingId: params.listingId,
          individualThresholdId: params.threshold || params.threshold_id || params.t || params.thresholdid,
          webKey: params.webKey || params.web_key || params.webkey,
          autoplay: params.autoplay || true,
          title: params.title || false,
          flex: params.flexible || true,
          speed: params.speed || 1
        };
    window.threshold.Viewer(options);
  }
)
